import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import * as FPT from '../utility/fpt';
import { localsMessages } from '../utility/getTemplateData';
const messages = localsMessages('confirmation/confirmation');

const styles = StyleSheet.create({
  primaryText: {
    fontFamily: 'pp-sans-small-medium',
    fontSize: '15px',
    lineHeight: '1.3',
    letterSpacing: '0.5px',
    color: '#2f73bb',
  },
  promotionContainer: {
    cursor: 'pointer',
    margin: '22px 0',
    paddingTop: '20px',
    paddingBottom: '20px',
    backgroundColor: 'white',
    borderRadius: '5px',
    border: '1px solid rgba(144, 145, 150, 0.33)',
    '@media (max-width: 736px)': {
      margin: '22px',
    },
  },
  promotionContent: {
    display: 'flex',
    flexDirection: 'row',
  },
  iconContainer: {
    flex: '0 0 60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class HurricaneHarveyCard extends React.Component {
  static propTypes = {
    pageName: PropTypes.string,
  };

  componentDidMount() {
    FPT.trackPage(
      `main:donate:wps:${this.props.pageName}:success`,
      `main:donate:wps:${this.props.pageName}:success:web::`,
      'hurricane-harvey',
      this.props.pageName
    );
  }

  handlePromotionClick = () => {
    FPT.trackLinkClickWithData('hurricane-harvey', {
      confirmationPage: this.props.pageName,
    });
    window.open('https://www.paypal.com/fundraiser/107638597766619098');
  };

  render() {
    return (
      <div
        className={`${css(styles.promotionContainer)}`}
        onClick={this.handlePromotionClick}
      >
        <div className={`${css(styles.promotionContent)}`}>
          <div className={`${css(styles.iconContainer)}`}>
            <img
              src="https://www.paypalobjects.com/images/Cause/hurricaneharvey/DonateHandSmall.png"
              width="32px"
            />
          </div>
          <div className={` ${css(styles.primaryText)}`}>
            {messages.label.learnHurricaneHarvey}
          </div>
        </div>
      </div>
    );
  }
}

export default HurricaneHarveyCard;
